import React from 'react'
import { RegisterOptions, UseFormReturn } from 'react-hook-form'
import { emailInputProps } from './props-autocomplete'
import { GenericTextInput } from './default-text-input'
import { useReduxSelector } from '../../hooks'

type Props = {
  form: UseFormReturn<any>
  name: string
  variant?: 'standard' | 'filled' | 'outlined'
  placeholder?: string
  disabled?: boolean
  options?: RegisterOptions
}

export const EmailInput: React.FC<Props> = ({
  name,
  form,
  variant = 'outlined',
  placeholder,
  disabled = false,
  options,
}): JSX.Element => {
  const { register, formState } = form
  const { data: constants } = useReduxSelector((state) => state.constants)

  return (
    <GenericTextInput
      register={register(name, {
        required: true,
        ...options,
      })}
      placeholder={placeholder}
      disabled={disabled}
      label="E-mail"
      variant={variant}
      type="email"
      InputProps={{ inputProps: { ...(emailInputProps as any) } }}
      helperText={formState.errors[name]?.message}
    />
  )
}
